import request from "@/utils/request";

/**
 *
 * @param {Object} data {
 *  code(String: false): 开启验证码手机号模式输入验证码
 *  password(String: false): 用户名密码
 *  type(String: true): PASSWORD,MOBILE,EMAIL三种模式
 *  unique(String: false): 密码加密输入加密unique
 *  username(String: true): 密码及验证码模式输入用户名,手机号模式输入手机号,邮箱模式输入邮箱
 * }
 * @returns
 */
export function login(data) {
  return request({
    url: "/api/v1/portal/login",
    method: "post",
    data,
  });
}

export function getInfo() {
  return request({
    url: "/api/v1/portalmanage/user/userInfo",
    method: "get",
  });
}

export function logout() {
  return request({
    url: "/api/v1/portal/logout",
    method: "get",
  });
}

/**
 * 修改个人信息
 * @param {*} params {
 *  adminName: String,
 *  adminPhone: String
 * }
 */
export function updateUserInfo(params) {
  return request({
    url: "/api/v1/user/modify",
    method: "put",
    params,
  });
}

/**
 * 用户注册
 */
export function register(data) {
  return request({
    url: "/api/v1/portal/register",
    method: "post",
    data,
  });
}

/**
 * 发送登录验证码
 */
export function sendSms(data) {
  let url = "",
    { type, phone } = data;
  switch (type) {
    case "password":
      url = "/api/v1/portal/sms/send/modifypassword";
      break;
    case "register":
      url = "/api/v1/portal/sms/send/register";
      break;
    case "resetPhoneOld":
      url = "/api/v1/portalmanage/user/modify-phone/old/send-sms";
      break;
    case "resetPhoneNew":
      url = "/api/v1/portalmanage/user/modify-phone/new/send-sms";
      break;
    case "resetPassword":
      url = "/api/v1/portalmanage/user/modify-password/send-sms";
      break;
    case "unsubscribe":
      url = "/api/v1/portalmanage/user/cancle/send-sms";
      break;
    default:
      // login
      url = "/api/v1/portal/sms/send/login";
      break;
  }
  return request({
    url,
    method: "post",
    params: { phone },
  });
}

/**
 * 个人申请实名认证
 */
export function applyPersonal(data) {
  return request({
    url: "/api/v1/portalmanage/user/apply/personal",
    method: "post",
    data,
  });
}

/**
 * 获取实名认证信息
 */
export function getApplyPersonal() {
  return request({
    url: "/api/v1/portalmanage/user/apply/personal",
    method: "get",
  });
}

/**
 * 申请专家认证
 */
export function applyExpert(data) {
  return request({
    url: "/api/v1/portalmanage/user/apply/expert",
    method: "post",
    data,
  });
}

/**
 * 获取专家认证信息
 */
export function getApplyExpert() {
  return request({
    url: "/api/v1/portalmanage/user/apply/expert",
    method: "get",
  });
}

/**
 * 申请企业认证
 */
export function applyEnterprise(data) {
  return request({
    url: "/api/v1/portalmanage/user/apply/enterprise",
    method: "post",
    data,
  });
}

/**
 * 获取企业认证信息
 */
export function getApplyEnterprise() {
  return request({
    url: "/api/v1/portalmanage/user/apply/enterprise",
    method: "get",
  });
}

/**
 * 修改手机号码-验证旧手机的短信验证码
 */
export function verifyCode(data) {
  return request({
    url: "/api/v1/portalmanage/user/modify-phone/verify-code",
    method: "post",
    params: data,
  });
}

/**
 * 修改手机号码-验证新手机的短信验证码，并修改手机号
 */
export function modifyPhone(data) {
  return request({
    url: "/api/v1/portalmanage/user/modify-phone",
    method: "post",
    params: data,
  });
}

/**
 * 修改密码-验证短信验证码
 */
export function verifyPassword(data) {
  return request({
    url: "/api/v1/portalmanage/user/modify-password/verify-code",
    method: "post",
    params: data,
  });
}

/**
 * 修改密码
 */
export function modifyPassword(data) {
  return request({
    url: "/api/v1/portalmanage/user/modify-password",
    method: "post",
    params: data,
  });
}

/**
 * 注销账户-验证短信并注销账号
 */
export function unsubscribe(data) {
  return request({
    url: "/api/v1/portalmanage/user/cancle",
    method: "post",
    params: data,
  });
}

/**
 * 获取加密参数
 */
export function getEncryptedString() {
  return request({
    url: "/api/v1/portal/login/getEncryptedString",
    method: "get",
  });
}

export default {
  login,
  getInfo,
  logout,
  updateUserInfo,
  modifyPassword,
  sendSms,
  verifyCode,
  modifyPhone,
  getEncryptedString,
};
